import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  // 支付页面
  getTransactions: params => axios({ baseURL, url: '/api/payment/transactions', params, method: 'get' }), // 交易流水
  getCreditCards: params => axios({ baseURL, url: '/api/payment/creditCards', params, method: 'get' }), // 信用卡
  getBalance: () => axios({ baseURL, url: '/api/payment/balance', method: 'get' }), // 余额
  deleteCreditCard: id => axios({ baseURL, url: `/api/payment/creditCards/${id}`, method: 'delete' }), // 删除信用卡
  changeCreditCard: data => axios({ baseURL, url: '/api/payment/creditCards', data, method: 'put' }), // 修改信用卡
  addCreditCard: data => axios({ baseURL, url: '/api/payment/creditCards', data, method: 'post' }), // 添加信用卡
  exportPayment: params => axios({ baseURL, url: '/api/payment/transactionsExport', params, method: 'get' }), // 导出

  // 创建卡包 Airwallex自动付款
  getAirwallexClientSecret: params => axios({ baseURL, url: '/api/payment/airwallex/customers/clientSecret', params, method: 'get' }), // 自动付款-获取用户clientSecret
  addPaymentPaymentConsent: data => axios({ baseURL, url: '/api/payment/paymentConsents', data, method: 'post' }), // 自动付款-新增付款意向
  getPaymentPaymentConsent: params => axios({ baseURL, url: '/api/payment/paymentConsents', params, method: 'get' }), // 自动付款-付款意向列表
  deletePaymentPaymentConsent: id => axios({ baseURL, url: `/api/payment/paymentConsents/${id}/disable`, method: 'put' }), // 自动付款-删除支付意向
  sortPaymentPaymentConsent: id => axios({ baseURL, url: `/api/payment/paymentConsents/${id}/sort`, method: 'put' }), // 自动付款-设置为默认

  getCreditUserInfo: () => axios({ baseURL, url: '/api/payment/bill/credit', method: 'GET' }), // 查询当前用户信用信息
  getIssuedBillsList: (data) => axios({ baseURL, url: '/api/payment/bill/getBilleds', method: 'POST', data }), // 获取已出账账单列表(前台)
  getBillDetailsById: (billId, params) => axios({ url: `/api/payment/bill/billedDetail/${billId}`, method: 'GET', params }), // 根据账单ID获取账单详情(前后台同一个接口)
  getUnpublishedBillsList: (data) => axios({ url: '/api/payment/bill/getBills', method: 'POST', data }), // 获取未出账账单列表(前台)
  getCreateTransactionOrder: (data) => axios({ baseURL, url: '/api/payment/transaction', method: 'POST', data }), // 创建交易单
  startBalancePayment: (paymentId) => axios({ baseURL, url: `/api/payment/balance/${paymentId}`, method: 'POST' }), // 余额付款

  getCouponsList: (params) => axios({ url: '/api/product/userCouponTicketCollectionForm', method: 'GET', params }) // 前台（PC端或移动端）- 获取用户优惠券列表
}
